/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateAudioChannelMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateAudioChannelMutationOpResult = { updateNodes: Array<{ error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null }> };

export type AudioChannelStartIdentifyMutationVariables = Types.Exact<{
  startAudioChannelIdentifyId: Types.Scalars['ID']['input'];
}>;


export type AudioChannelStartIdentifyMutationOpResult = { startAudioChannelIdentify: { error: { code: Types.ErrorCode, message: string } | null } };

export type AudioChannelStopIdentifyMutationVariables = Types.Exact<{
  stopAudioChannelIdentifyId: Types.Scalars['ID']['input'];
}>;


export type AudioChannelStopIdentifyMutationOpResult = { stopAudioChannelIdentify: { error: { code: Types.ErrorCode, message: string } | null } };

export type UpdatePassiveSpeakerMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdatePassiveSpeakerMutationOpResult = { updateNodes: Array<{ error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null } | { error: { code: Types.ErrorCode, message: string } | null }> };

export const UpdateAudioChannelMutationDocument = gql`
    mutation UpdateAudioChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAudioChannelMutationGQL extends Apollo.Mutation<UpdateAudioChannelMutationOpResult, UpdateAudioChannelMutationVariables> {
    override document = UpdateAudioChannelMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AudioChannelStartIdentifyMutationDocument = gql`
    mutation AudioChannelStartIdentifyMutation($startAudioChannelIdentifyId: ID!) {
  startAudioChannelIdentify(id: $startAudioChannelIdentifyId) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AudioChannelStartIdentifyMutationGQL extends Apollo.Mutation<AudioChannelStartIdentifyMutationOpResult, AudioChannelStartIdentifyMutationVariables> {
    override document = AudioChannelStartIdentifyMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AudioChannelStopIdentifyMutationDocument = gql`
    mutation AudioChannelStopIdentifyMutation($stopAudioChannelIdentifyId: ID!) {
  stopAudioChannelIdentify(id: $stopAudioChannelIdentifyId) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AudioChannelStopIdentifyMutationGQL extends Apollo.Mutation<AudioChannelStopIdentifyMutationOpResult, AudioChannelStopIdentifyMutationVariables> {
    override document = AudioChannelStopIdentifyMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePassiveSpeakerMutationDocument = gql`
    mutation UpdatePassiveSpeakerMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePassiveSpeakerMutationGQL extends Apollo.Mutation<UpdatePassiveSpeakerMutationOpResult, UpdatePassiveSpeakerMutationVariables> {
    override document = UpdatePassiveSpeakerMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }